/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Assignment } from '../../models/assignment';
import { AssignmentWithStudentIds } from '../../models/assignment-with-student-ids';

export interface GetSchoolAssignments$Params {
  id: string;
}

export function getSchoolAssignments(http: HttpClient, rootUrl: string, params: GetSchoolAssignments$Params, context?: HttpContext): Observable<StrictHttpResponse<(Assignment | AssignmentWithStudentIds)>> {
  const rb = new RequestBuilder(rootUrl, getSchoolAssignments.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<(Assignment | AssignmentWithStudentIds)>;
    })
  );
}

getSchoolAssignments.PATH = '/school/{id}/assignments';
